<nb-card [nbSpinner]="loading" class="card-box" id="card-box">
  <nb-card-header class="content-header">
    <nb-icon class="icon" icon="play-circle-outline" status="basic"></nb-icon>
    <span class="title">{{ "common.print-file" | translate }}</span>
    <nb-icon
      icon="question-mark-circle-outline"
      nbTooltipStatus="control"
      class="me-2 cursor-help"
      nbTooltip="{{ 'tooltips.confirm-printing-file' | translate }}"
      nbTooltipPlacement="left"
    ></nb-icon>
    <nb-icon class="close" icon="close-outline" (click)="close()"></nb-icon>
  </nb-card-header>
  <nb-card-body class="confirmation-box">
    <div class="image-box">
      <img
        [class.image-box__image]="modalData.file.preview"
        [src]="modalData.file.preview"
        appImgFallback
        [removeClassesOnError]="true"
        alt="roboze-photo"
      />
    </div>
    <div class="file-name-box">
      {{ modalData.file.name }}
    </div>
    <div class="device-type-box">
      {{ "device.details.model" | translate }}:
      <span class="value">Roboze {{ modalData.device.type }}</span>
    </div>
    <div class="material-box" *ngFor="let metadata of modalData.file.materials">
      {{ "device.files.printing-material" | translate }}:
      <span class="value">{{ metadata?.name }}</span> ({{
        metadata.used | number : "1.0-3"
      }}{{ metadata.unit }})
    </div>
  </nb-card-body>
  <nb-card-body
    *ngIf="differentMaterials || chamberTemperatureNotStabilized"
    class="content-body__error"
  >
    <div class="icon">
      <nb-checkbox
        [checked]="isChecked"
        status="basic"
        (checkedChange)="confirmPrint($event)"
      >
      </nb-checkbox>
    </div>

    <div class="text" (click)="confirmPrint(!isChecked)">
      {{ "common.warning" | translate }}!
      <ng-container *ngIf="differentMaterials">
        {{ "bulk.warning-force-print" | translate }}
      </ng-container >

      <ng-container *ngIf="chamberTemperatureNotStabilized">
        {{ "bulk.warning-chamber-temperature-not-stabilized" | translate }}
      </ng-container>
      {{ "bulk.confirm-force-print" | translate }}
    </div>
  </nb-card-body>
  <nb-card-body *ngIf="noMainMaterialLoaded" class="content-body__error">
    <div class="text justify-content-center">
      {{ "common.warning" | translate }}!
      {{ "bulk.no-main-material-loaded" | translate }}
    </div>
  </nb-card-body>
  <nb-card-footer class="content-footer">
    <button
      nbButton
      [size]="'large'"
      [status]="'control'"
      [appearance]="'outline'"
      (click)="close()"
      tabindex="-1"
    >
      {{ "common.close" | translate }}
    </button>
    <button
      nbButton
      status="primary"
      *ngIf="!noMainMaterialLoaded"
      [size]="'large'"
      [disabled]="
        differentMaterials && chamberTemperatureNotStabilized && !isChecked
      "
      (click)="printFile()"
      tabindex="-1"
    >
      {{ "device.buttons.print" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
